import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProgressService} from '../../service/progress.service';
import {BaseModalComponent} from '../../common/modal/base-modal/base-modal.component';
import {EditorComponent} from '@tinymce/tinymce-angular';
import {Contest} from '../../model/contest/Contest';
import {UrlHelper} from '../../helper/url.helper';

export interface ContestDetailsData {
  competitionId: string;
  contest?: Contest;
}

@Component({
  selector: 'app-contest-details-modal',
  templateUrl: './contest-preview-modal.component.html',
  styleUrls: ['./contest-preview-modal.component.scss'],
})
export class ContestPreviewModalComponent extends BaseModalComponent {

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;
  @ViewChild('editorComponent', {static: true}) editor!: EditorComponent;

  readonly competitionId?: string;
  readonly contest?: Contest;

  constructor(dialogRef: MatDialogRef<ContestPreviewModalComponent>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: ContestDetailsData) {
    super(dialogRef, progressService);

    this.competitionId = data?.competitionId;
    this.contest = data?.contest;
  }

  get getPreviewUrl(): string {
    return this.contest
      ? UrlHelper.CONTEST_EXAM_PATH + this.contest.id
      : '';
  }

  proceed(): void {
  }

  proceedAllowed(): boolean {
    return true;
  }

}
